// removed by extract-text-webpack-plugin
module.exports = {"message":"message-1mmAo","box":"box-2hfVL"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/validations/validation.less
 ** module id = 183
 ** module chunks = 0
 **/